import PATHS from '../constants';

function fetchAboutUs() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_ABOUT_US, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchAboutUs;